import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Rating
} from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const ReviewsSection = ({ salon, isMobile = false }) => {
  const { t } = useTranslation();
  // Don't render if no GMB URL is provided
  if (!salon?.googleMyBusinessUrl) {
    return null;
  }

  if (isMobile) {
    return (
      <Card sx={{ mt: 3, borderRadius: 2, border: '1px solid #E5E7EB' }}>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#000000' }}>
            {t('salon.googleReviews')}
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Rating value={5} precision={0.1} readOnly size="small" />
            <Typography variant="body2" sx={{ color: '#6B7280' }}>
              {t('salon.ratingOutOf5')}
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <a
              href={salon.googleMyBusinessUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none',
                color: '#1976d2',
                fontSize: '0.875rem',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              {t('salon.viewAllGoogleReviews')} →
            </a>
          </Box>
        </CardContent>
      </Card>
    );
  }

  // Desktop version
  return (
    <Card sx={{ mt: 3, borderRadius: 2, border: '1px solid #E5E7EB' }}>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
          {t('salon.googleReviews')}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Rating value={5} precision={0.1} readOnly />
          <Typography variant="body1" sx={{ color: '#6B7280' }}>
            {t('salon.ratingOutOf5')}
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <a
            href={salon.googleMyBusinessUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: 'none',
              color: '#1976d2',
              fontSize: '1rem',
              fontWeight: 500,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            {t('salon.viewAllGoogleReviews')} →
          </a>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ReviewsSection;